// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"ManageDiscount_pageHolder__2EYp0","MeniPartHolder":"ManageDiscount_MeniPartHolder__1L9A5","MeniPartHolder__EachPart":"ManageDiscount_MeniPartHolder__EachPart__2Zu0s"};